document.addEventListener("DOMContentLoaded", function(event){
  const readmore = document.querySelector('.seo-readmore .readmore-container a');
  const content = document.querySelector('.seo-readmore .hide-content');
  readmore.addEventListener('click', function(e){
    e.preventDefault();
    content.classList.toggle('show');
    if (content.classList.contains('show')) {
      readmore.innerHTML = 'Read Less';
    } else {
      readmore.innerHTML = 'Read More';
    }
  });
});